"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducerQueryUser = reducerQueryUser;
const ts_exhaustive_check_1 = require("ts-exhaustive-check");
const GraphQLEntityCache = __importStar(require("gql-cache"));
const GQLCachePatch = __importStar(require("gql-cache-patch"));
const GraphQLMutationsQueue = __importStar(require("@genesys/graphql-mutations-queue"));
const initialState = {
    entities: {},
    mutationQueues: {}
};
function reducerQueryUser(state = initialState, action) {
    switch (action.type) {
        case "query-user/MergeUserEntities": {
            return Object.assign(Object.assign({}, state), { entities: mergeUserEntities(state.entities, action.payload.entities, action.payload.cachePatches) });
        }
        case "query-user/queue-mutations": {
            const queue = state.mutationQueues[action.queueId] ||
                GraphQLMutationsQueue.EmptyQueue;
            const updatedQueue = GraphQLMutationsQueue.reducer(queue, GraphQLMutationsQueue.queueMany(action.payload));
            return Object.assign(Object.assign({}, state), { mutationQueues: Object.assign(Object.assign({}, state.mutationQueues), { [action.queueId]: updatedQueue }) });
        }
        case "query-user/de-queue-mutations": {
            const queue = state.mutationQueues[action.queueId] ||
                GraphQLMutationsQueue.EmptyQueue;
            const updatedQueue = GraphQLMutationsQueue.reducer(queue, GraphQLMutationsQueue.dequeueMany(action.payload));
            return Object.assign(Object.assign({}, state), { mutationQueues: Object.assign(Object.assign({}, state.mutationQueues), { [action.queueId]: updatedQueue }) });
        }
        case "query-user/discard-mutations-queue": {
            return Object.assign(Object.assign({}, state), { mutationQueues: Object.assign(Object.assign({}, state.mutationQueues), { [action.queueId]: GraphQLMutationsQueue.EmptyQueue }) });
        }
        case "query-user/MergeUserEntitiesAndDeuqueQueuedMutations": {
            const queue = state.mutationQueues[action.payload.queueId] ||
                GraphQLMutationsQueue.EmptyQueue;
            const updatedQueue = GraphQLMutationsQueue.reducer(queue, GraphQLMutationsQueue.dequeueMany(action.payload.mutationsToDequeue));
            return Object.assign(Object.assign({}, state), { entities: mergeUserEntities(state.entities, action.payload.entities, action.payload.cachePatches), mutationQueues: Object.assign(Object.assign({}, state.mutationQueues), { [action.payload.queueId]: updatedQueue }) });
        }
        case "query-user/ApplyCachePathes": {
            return Object.assign(Object.assign({}, state), { entities: mergeUserEntities(state.entities, {}, action.payload) });
        }
        default:
            (0, ts_exhaustive_check_1.exhaustiveCheck)(action);
            return state;
    }
}
function mergeUserEntities(stateEntities, newEntities, cachePatches) {
    const mergedCache = GraphQLEntityCache.mergeEntityCache(stateEntities, newEntities);
    const [cachePatchesAppliedCache, staleEntities] = GQLCachePatch.apply(cachePatches, mergedCache, GraphQLMutationsQueue.getStaleEntities(mergedCache));
    const updatedStaleEntities = GraphQLEntityCache.updateStale(newEntities, staleEntities);
    return GraphQLMutationsQueue.setStaleEntities(cachePatchesAppliedCache, updatedStaleEntities);
}
//# sourceMappingURL=reducer-user.js.map